// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20bsg","importantInfo":"styles_importantInfo__1LwXa"};